import app from './app'

app.$mount('#app')



// WEBPACK FOOTER //
// ./C:/Users/schulz/web/steam-achievements2/src/index.js